import fetchServer from "../helpers/api/fetchServer";

export const getPaginatedETLTasks = async ({
  filterText,
  filterStartDate,
  filterEndDate,
  filterIsCompleted,
  filterHasError,
  filterDeleted,
  sortBy,
  page,
  nbDocsPerPage,
}) => {
  const method = "GET";
  let urlAPI = "/api/ETLTasks?";
  // Filters
  if (filterText) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `text=${filterText}`;
  }
  if (filterStartDate) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `startDate=${filterStartDate}`;
  }
  if (filterEndDate) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `endDate=${filterEndDate}`;
  }
  if (typeof filterIsCompleted === "boolean") {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `isCompleted=${filterIsCompleted}`;
  }
  if (typeof filterHasError === "boolean") {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `hasError=${filterHasError}`;
  }
  if (filterDeleted) {
    if (urlAPI.slice(-1) !== "?") {
      urlAPI += "&";
    }
    urlAPI += `deleted=${filterDeleted}`;
  }
  // Sort by
  if (urlAPI.slice(-1) !== "?") {
    urlAPI += "&";
  }

  urlAPI += `sortBy=${sortBy}`;

  // Pagination
  urlAPI += `&page=${page}&nbDocsPerPage=${nbDocsPerPage}`;

  return await fetchServer({ method, urlAPI });
};

export const getETLTasksByETLRun = async (ETLRunId) => {
  const method = "GET";
  let urlAPI = `/api/ETLTasks?ETLRun=${ETLRunId}`;
  return await fetchServer({ method, urlAPI });
};

export const getETLTask = async (id) => {
  const method = "GET";
  const urlAPI = `/api/ETLTasks/${id}`;
  return await fetchServer({ method, urlAPI });
};
